import Button from 'components/shared/button'
import * as T from 'components/ui/typography'
import Image from 'next/image'
import DuelEmptyState from 'public/images/duel-empty-state.svg'
import QuizEmptyState from 'public/images/quiz-empty-state.svg'
import SimEmptyState from 'public/images/simulations-empty-state.svg'
import TheoryEmptyState from 'public/images/theory-empty-state.svg'
import React from 'react'

interface PropsEmptyPage {
    title: string
    description: string
    image: string
    textButton?: string
    onClickButton?: () => void
    refButton?: string
}

const EmptyPage = (props: PropsEmptyPage) => {
    const image = React.useMemo(() => {
        if (props.image === 'duel') return <DuelEmptyState viewBox="-30 -20 300 300" />
        if (props.image === 'quiz') return <QuizEmptyState viewBox="-10 -20 300 300" />
        if (props.image === 'simulations') return <SimEmptyState viewBox="-10 -20 300 300" />
        if (props.image === 'theory') return <TheoryEmptyState viewBox="-10 -10 120 120" />
        return <Image src={props.image} alt={props.image} width={200} height={200} />
    }, [props.image])

    return (
        <div className="flex flex-col items-center text-center">
            {props.image && <div>{image}</div>}

            <T.H3 className="pb-3 text-center">{props.title}</T.H3>

            <T.P className="pb-3 text-center text-neutral-500">{props.description}</T.P>

            {props.onClickButton && <Button onClick={props.onClickButton}>{props.textButton || ''}</Button>}
        </div>
    )
}

interface PropsEmptyPageSimulations {
    title: string
    description: string
    textButton?: string
    onClickButton?: () => void
    refButton?: string
}

export const EmptyPageSimulations = (props: PropsEmptyPageSimulations) => {
    return (
        <EmptyPage
            title={props.title}
            description={props.description}
            image="simulations"
            onClickButton={props.onClickButton}
            textButton="Inizia una simulazione"
        />
    )
}

export const EmptyPageChallenge = (props: PropsEmptyPageSimulations) => {
    return (
        <EmptyPage
            title={props.title}
            description={props.description}
            textButton={props.textButton}
            onClickButton={props.onClickButton}
            image="duel"
        />
    )
}

export const EmptyPageQuiz = (props: PropsEmptyPageSimulations) => {
    return (
        <EmptyPage
            title={props.title}
            description={props.description}
            textButton={props.textButton}
            onClickButton={props.onClickButton}
            image="quiz"
        />
    )
}

export const EmptyPageTheory = (props: PropsEmptyPageSimulations) => {
    return (
        <EmptyPage
            title={props.title}
            description={props.description}
            textButton={props.textButton}
            onClickButton={props.onClickButton}
            image="theory"
        />
    )
}

export default EmptyPage
